(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "67e4f33d54ec4e0b590a0f82";
              window.beaePageSetting.pageTitle = "Contact Form"; 
              window.beaePageSetting.pageType = "page";

          let js_O3DQN62O = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-2xwl2yq6section-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-2xwl2yq6',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-2xwl2yq6');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-2xwl2yq6: ', ex)
      };
    

      try {
        let argid = 'beae-kriycmyiblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kriycmyi',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kriycmyi');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kriycmyi: ', ex)
      };
    

      try {
        let argid = 'beae-jni9urw4section-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jni9urw4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jni9urw4');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jni9urw4: ', ex)
      };
    

      try {
        let argid = 'beae-yvy7ra7xblock-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-yvy7ra7x',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-yvy7ra7x');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-yvy7ra7x: ', ex)
      };
    

      try {
        let argid = 'beae-jx910782block-textloop-0',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jx910782',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jx910782');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jx910782: ', ex)
      };
    

      try {
        let argid = 'beae-yvy7ra7xblock-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-yvy7ra7x',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-yvy7ra7x');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-yvy7ra7x: ', ex)
      };
    

      try {
        let argid = 'beae-jx910782block-textloop-1',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-jx910782',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-jx910782');
        args.el = args.els[1];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-jx910782: ', ex)
      };
    

      try {
        let argid = 'beae-sdksujd7block-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-sdksujd7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-sdksujd7');
        args.el = args.els[0];
        ((b) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,p=b.el.querySelector("form");b.el.querySelector(".beae-btn-pr");const f=b.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),m=b.el.querySelector(".btn-lightbox-form > button");!h&&b.mode.value!=="builder"&&(b.el.querySelector(".beae-form-success-message").style="display: none"),h&&b.afterSubmitting=="redirect"&&b.redirect&&(b.el.querySelector(".beae-form-success-message").style="display: block",window.location.href=b.redirect);const k=[];p&&p.addEventListener("submit",g=>{g.preventDefault();for(let v=0;v<f.length;v++)k.push({fieldKey:f[v].name,fieldType:f[v].type,fieldValue:f[v].value})}),m&&(m.onclick=()=>{const g=document.createElement("div");g.innerHTML=p.outerHTML||"",window.BeaePopupLibrary.createPopup(g,{layout:"center",layoutMobile:"bottom",width:"500px",id:b.id})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-sdksujd7: ', ex)
      };
    }; if (window.BEAEBASE) {js_O3DQN62O()} else {window.BEAEPAGEJS.push(js_O3DQN62O)} })(); 